<template>
    <div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="username">Email * <span v-if="v$.member.username.$invalid" class="p-invalid">Mangler</span></label>
                <InputText id="username" type="username" v-model="v$.member.username.$model"
                    @blur="v$.member.username.$touch" :class="{ 'p-invalid': v$.member.username.$invalid }" />
            </div>
            <div class="field col-12">
                <label for="email">Password * <span v-if="v$.member.password.$invalid" class="p-invalid">Mangler</span></label>
                <Password v-model="v$.member.password.$model" :feedback="false" @blur="v$.member.password.$touch"
                    :class="{ 'p-invalid': v$.member.password.$invalid }" />
            </div>
            <div class="field field-checkbox col">
                <Checkbox inputId="rememberMe" v-model="member.rememberMe" :binary="true" />
                <label :for="rememberMe">Husk mig</label>
            </div>
            <div class="field col" style="text-align:right">
                <a @click="this.$emit('initPasswordReset')">Glemt adgangskode?</a>
            </div>
            <div class="field col-12">
                <Button class="p-button-primary" @click="loginMember">Log ind</Button>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import VueHelpers from './../vueHelpers';

import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'

export default {
    name: "loginMemberForm",
    components: {
        Button,
        InputText,
        Toast,
        Password,
        Checkbox
    },
    data() {
        return {
            dictionary: [],
            member: {
                username: null,
                password: null,
                rememberMe: false
            },
            lastAction: null,
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },

    created() {
        const vm = this;
        vm.lastAction = VueHelpers.getTimestampInSeconds();

        fetch(`/umbraco/api/resourcesApi/GetLoginFormDictionary`).then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

    },
    validations() {
        return {
            member: {
                username: { required, email, $lazy: true },
                password: {
                    required,
                    minLengthValue: minLength(10),
                    $lazy: true
                }
            }

        }
    },
    methods: {
        async loginMember() {
            const vm = this;
            const isValid = await this.v$.$validate()
            if (isValid) {
                if (VueHelpers.getTimeDifferenceInSeconds(vm.lastAction) > 3) {
                    vm.$emit("loading", true);

                    var postModel = {...vm.member};
                    postModel['likedCars'] = localStorage.getItem(VueHelpers.favoritesCacheKey);

                    fetch('/umbraco/api/memberapi/LoginMember', {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json",
                            "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                        },
                        body: JSON.stringify(postModel),
                    }).then(response => {
                        if (response.status == 404) {
                            vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberUnknownUserNotificationTitle, detail: vm.dictionary.memberUnknownUserNotificationText, life: 10000 });
                        }
                        return response;
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.id != 0) {
                                localStorage.removeItem(VueHelpers.favoritesCacheKey);
                                vm.$emit('loggedIn', data);
                            }
                            vm.$emit("loading", false);

                        }).catch(error => {
                            console.log(error);
                            vm.$emit("loading", false);
                            vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                        });

                    vm.lastAction = VueHelpers.getTimestampInSeconds();
                }
            } else {
                vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberCommonInvalidInfoNotificationTitle, detail: vm.dictionary.memberCommonInvalidInfoNotificationText, life: 10000 });
            }
        }
    }
};
</script>
